import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Link } from "@sunwing/wvi-components";

import * as styles from "./hotel-brand-card.module.scss";

const HotelBrandCard = ({ logo, chainName, link, classNames }) => (
	<div className={cx(styles.hotelBrandCard, classNames)}>
		{logo && (
			<img
				src={logo}
				alt={chainName}
				loading="lazy"
				onError={e => {
					e.target.style.display = "none";
				}}
			/>
		)}
		<span className={styles.brandOverlay}>{chainName}</span>
		{link && (
			<Link className={styles.hotelBrandCardLink} href={link}>
				<span className="sr-only">{chainName}</span>
			</Link>
		)}
	</div>
);

HotelBrandCard.propTypes = {
	logo: PropTypes.string,
	link: PropTypes.string,
	chainName: PropTypes.string.isRequired,
	classNames: PropTypes.string,
};

HotelBrandCard.defaultProps = {
	logo: null,
	link: null,
	classNames: undefined,
};

export { HotelBrandCard };
export default HotelBrandCard;
